export const TRANSLATIONS_DE = {
  email: "E-Mail",
  password: "Passwort",
  address: "Adresse",
  login_credentials: "Anmeldedaten",
  forgotpassword: "Passwort vergessen? ",
  email_field_is_required: "E-Mail-Feld ist erforderlich",
  reset_password: "Passwort zurücksetzen",
  password_field_is_required: "Passwort-Feld ist erforderlich",
  password_do_not_match: "Passwort stimmt nicht überein",
  invalid_email_address: "Ungültige E-Mail-Adresse",
  leave_empty_to_keep_current: "Leer lassen, um das aktuelle Passwort zu behalten",
  enter_email_address: "E-Mail Adresse eingeben",
  create_account: "Konto erstellen",
  dont_have_an_account: "Sie haben kein Konto?",
  already_have_an_account: "Sie haben bereits ein Konto?",
  back_to_login: "Zurück zum Login",
  activate_account: "Konto aktivieren",
  activating_account: "Konto wird aktiviert...",
  activation_success: "Konto erfolgreich aktiviert!",
  activation_success_message:
    "Ihr Konto wurde erfolgreich aktiviert. Sie können sich jetzt anmelden.",
  activation_failed: "Aktivierung fehlgeschlagen",
  enter_the_email_address_associated_with_your_account_and_we_will_send_you_a_link_to_reset_your_password:
    "Geben Sie die mit Ihrer verknüpfte E-Mail-Adresse ein	Konto und wir senden Ihnen einen Link zum Zurücksetzen	Ihr Passwort.",
  water_stress: "Wasserstress",
  dashboard: {
    title: "Dashboard",
    view_trees: "Bäume anzeigen",
    view_sensors: "Sensoren anzeigen",
    greeting: "Hallo",
    data_status: "Datenstand",
    all_locations: "Alle Standorte",
    last_30_days: "Letzte 30 Tage",
    top_species: "Top 5 Baumarten",
    top_species_info_title: "Top 5 Baumarten",
    top_species_info_body:
      "Zeigt die haeufigsten Baumarten im aktuellen Filter. Die Werte basieren auf der Anzahl der Baeume pro Art.",
    tasks_by_due_period: "Aufgaben nach Zeitraum",
    view_tasks: "Zu den Aufgaben",
    health_last_30_days: "Gesundheit der letzten 30 Tage",
    tree_health: "Baumgesundheit",
    health_overview: "Übersicht",
    group_inventory: "Baumbestand",
    group_biometrics: "Baumbiometrie",
    group_sensors: "Sensorik & Status",
    group_recommendations: "Empfehlungen",
    kpi_total_trees: "Anzahl der Bäume",
    kpi_total_species: "Anzahl der Baumarten",
    kpi_total_sensors: "Anzahl der Sensoren",
    kpi_sensor_types: "Sensorarten",
    kpi_maintenance_sensors: "Sensor misst unplausible Werte",
    kpi_avg_height: "Durchschnittliche Höhe",
    kpi_avg_trunk_circumference: "Durchschnittlicher Stammumfang",
    kpi_avg_crown_diameter: "Durchschnittlicher Kronendurchmesser",
    kpi_avg_age: "Durchschnittliches Alter",
    kpi_critical_sensors: "Leere Batterie",
    kpi_disconnected_sensors: "Getrennte Sensoren (letzte 3 Stunden)",
    kpi_recommended_actions: "Bäume mit Handlungsempfehlung",
    sensor_types: "Sensortypen",
    avg_height: "Durchschnittliche Baumhöhe",
    avg_trunk_diameter: "Durchschnittlicher Baumdurchmesser",
    avg_crown_diameter: "Durchschnittlicher Kronendurchmesser",
    avg_age: "Durchschnittliches Baumalter",
    years_short: "Jahre",
    last_3_hours: "letzte 3 Std.",
    no_data: "Keine Daten verfügbar",
    no_health_data: "Keine Gesundheitsdaten verfügbar",
    overview: "Übersicht",
  },
  dashboards: "Dashboards",
  esg: {
    title: "ESG-Monitoring",
    subtitle: "Ressourceneffizienz",
    reporting_scope: "Berichtszeitraum",
    generate_pdf: "PDF erstellen",
    export_csv: "CSV exportieren",
    data_quality: "Datenqualität",
    completed_irrigation_volume: "Durchgeführtes Bewässerungsvolumen",
    estimated_water_saved: "Geschätzte Wassereinsparung",
    irrigation_efficiency: "Bewässerungseffizienz",
    estimated_co2_avoided: "Geschätzte CO2-Vermeidung",
    liters: "Liter",
    measured: "Gemessen",
    estimated: "Geschätzt",
    derived: "Abgeleitet",
    vs_last_period: "ggü. Vorperiode",
    irrigation_analysis: "Bewässerungsanalyse",
    monthly_comparison: "Monatsvergleich: Geschätzte Baseline vs. durchgeführte Bewässerung",
    monthly_comparison_through_current_month:
      "Monatlicher Vergleich bis einschließlich des aktuellen Monats",
    baseline: "Baseline",
    completed: "Durchgeführt",
    water_saved: "Wassereinsparung",
    methodology: "Methodik",
    calculation_basis: "Berechnungsgrundlage",
    data_coverage: "Datenabdeckung",
    included_assumptions: "Einbezogene Annahmen",
    exclusions: "Ausschlüsse & fehlende Daten",
    all_projects: "Alle Projekte",
    all_areas: "Alle Bereiche",
    disclaimer_title: "Haftungsausschluss",
    retry: "Erneut versuchen",
    // Methodik – Berechnungsgrundlage
    calc_volume_source:
      "Das durchgeführte Bewässerungsvolumen wird aus dokumentierten abgeschlossenen Bewässerungsaufgaben ermittelt.",
    calc_baseline_profile:
      "Die Baseline-Bewässerung nutzt TreeSense-Standard-Pflegeprofile basierend auf dem Baumalter (Pflanzjahr).",
    calc_seasonal_weighting:
      "Die monatliche Baseline wird über ein saisonales Gewichtungsprofil verteilt, konzentriert auf die Bewässerungssaison Apr–Sep.",
    calc_water_saved:
      "Wassereinsparung = Baseline minus durchgeführtes Bewässerungsvolumen, begrenzt auf ≥ 0.",
    calc_co2_explanation:
      "Die geschätzte CO₂e-Vermeidung wird in zwei Schritten berechnet. Zunächst wird die geschätzte Wassereinsparung mithilfe der angenommenen Energieintensität des Wassersystems in einen vermiedenen Strombedarf umgerechnet. Anschließend wird die eingesparte elektrische Energie mit dem Emissionsfaktor des Stroms multipliziert.",
    calc_co2_formula:
      "Geschätzte CO₂e-Vermeidung = Wassereinsparung (m³) × Energieintensität des Wassersystems (kWh/m³) × Emissionsfaktor des Stroms (kg CO₂e/kWh)",
    // Methodik – Einbezogene Annahmen
    assumption_young_0_1: "Jungbaum Jahr 0–1: 3.000 l/Jahr (20 Bewässerungen × 150 l)",
    assumption_young_2_3: "Jungbaum Jahre 2–3: 1.800 l/Jahr (12 Bewässerungen × 150 l)",
    assumption_years_4_7: "Jahre 4–7: 750 l/Jahr (5 Bewässerungen × 150 l)",
    assumption_established:
      "Etablierte Bäume (>7 Jahre): keine modellierte Baseline in dieser ersten Methodik (entspricht nicht null Bewässerungsbedarf).",
    assumption_energy_intensity:
      "Energieintensität des Wassersystems: 0,5 kWh/m³ (interne Annahme des ersten Entwurfs; noch nicht anhand lokaler Versorgerdaten validiert).",
    assumption_emission_factor:
      "Emissionsfaktor des Stroms: 0,4 kg CO₂e/kWh (interne Annahme des ersten Entwurfs; soll durch einen jahres- und regionsspezifischen Faktor ersetzt werden).",
    assumption_seasonal:
      "Saisonale Gewichtung: Baseline ist stark auf Apr–Sep konzentriert (~76 %), mit geringer Restgewichtung außerhalb der Hauptsaison.",
    // Methodik – Ausschlüsse
    exclusion_missing_planting_year:
      "{{count}} Baumdatensatz/-sätze aufgrund fehlenden Pflanzjahres von der Baseline ausgeschlossen.",
    exclusion_large_transplant:
      "Großverpflanzungs-Baseline ist noch nicht separat modelliert (kein verlässliches Identifikationsfeld).",
    exclusion_no_volume: "Aufgaben ohne extrahierbares Volumen werden ignoriert.",
    // Methodik – Haftungsausschluss
    disclaimer_text:
      "Das durchgeführte Bewässerungsvolumen basiert auf dokumentierten Bewässerungseinträgen in Litern, wie sie in der TreeSense-Plattform erfasst sind. Wassereinsparung und vermiedenes CO₂ sind geschätzte Werte, die mit standardisierten Methoden und Annahmen berechnet werden.",
    // Datenqualität
    quality_good: "Gut",
    quality_partial: "Teilweise",
    quality_insufficient: "Unzureichend",
    methodology_details: "Methodikdetails",
    methodology_version: "Version",
    methodology_updated: "Aktualisiert",
    methodology_first_draft: "Aktualisiert: erster Entwurf",
    // Methodik – Quellen
    references: "Quellen",
    references_explanation:
      "Das GHG Protocol dient als methodische Grundlage für die Umrechnung von Aktivitätsdaten und Stromverbrauch in Treibhausgasemissionen. Die TreeSense-Umrechnung von Wasser in Energie sowie die derzeit verwendeten Zahlenwerte sind interne Annahmen des ersten Entwurfs.",
    ref_corporate_standard: "GHG Protocol Corporate Standard",
    ref_scope2_guidance: "GHG Protocol Scope 2 Guidance",
    without_project_not_supported:
      "Das ESG-Monitoring ist für Bäume ohne Projekt noch nicht verfügbar. Wählen Sie ein Projekt oder Alle Projekte aus, um das Dashboard anzuzeigen.",
    year: "Jahr",
    area: "Gebiet",
  },
  newproject: "Neues Projekt",
  logout: "Abmelden",
  viewproject: "Projekt anzeigen",
  user: "Benutzer:in",
  users: "Benutzer:innen",
  persona: "Persona",
  username: "Benutzername",
  value: "Wert",
  date: "Datum",
  tree_and_sensor: "Baum & Sensor",
  rainfall_mm: "Niederschlag (mm)",
  zoom_in: "Hineinzoomen",
  reset_zoom: "Zoom zurücksetzen",
  restore_view: "Ansicht wiederherstellen",
  data_science_chart_tools: "Diagrammwerkzeuge",
  info: "Info",
  more_actions: "Mehr Aktionen",
  view_on_map: "Zur Karte",
  view_on_list: "Zur Liste",
  view_on_chart: "Zu Data Science",
  child_trees: "Repräsentierte Bäume",
  save: "Speichern",
  addTree: "Baum hinzufügen",
  name: "Name",
  image: "Bild",
  update: "Aktualisieren",
  login: "Anmeldung",
  signup: "Registrierung",
  delete: "Löschen",
  saving: "Speichern ...",
  edit: "Bearbeiten",
  project: {
    name: "Projekt",
    aim: "Projekttyp",
    select_aim: "Projekttyp auswählen",
    description: "Projektbeschreibung",
    description_placeholder: "Beschreiben Sie das Projekt kurz",
    research_question: "Forschungsfrage",
    research_question_placeholder: "Was ist die zentrale Forschungsfrage?",
    hypotheses: "Zu testende Hypothesen",
    hypotheses_placeholder: "Welche Hypothesen sollen getestet werden?",
    methodology: "Methodik",
    methodology_placeholder:
      "Beschreiben Sie die Methodik, Standorte, Baumauswahl und Sensormontage...",
    results: "Ergebnisse",
    results_placeholder: "Was sind die Hauptergebnisse des Projekts?",
    limitations: "Einschränkungen für das Ergebnis / Aussagekraft",
    limitations_placeholder:
      "Wie aussagekräftig sind die Ergebnisse? Welche Einschränkungen gibt es?",
    open_questions: "Offene Fragen / Nächste Schritte",
    open_questions_placeholder: "Welche Fragen sind noch offen? Was sind die nächsten Schritte?",
    challenges: "Probleme während des Projekts",
    challenges_placeholder: "Welche Probleme gab es? Was hat der Kunde benötigt?",
    materials: "Dateien/Fotos/Material aus dem Projekt",
    materials_placeholder: "Links zu Dateien, Fotos oder anderem Material",
    aim_old_tree_monitoring: "Altbaummonitoring",
    aim_irrigation_optimization_young_trees: "Bewässerungsoptimierung: Jungbäume",
    aim_technology_validation: "Technologie validieren",
    aim_smart_city: "Smart City",
    aim_partnership_project: "Partnerschaftsprojekt",
    aim_irrigation_optimization: "Bewässerungsoptimierung",
    aim_mistletoe_control: "Mistelbefall kontrollieren",
    aim_groundwater_lowering_monitoring: "Grundwasserabsenkung Monitoring",
    aim_general_drought_stress_monitoring: "Allgemeines Trockenstressmonitoring",
    aim_irrigation_demand_determination: "Bewässerungsbedarf erschließen",
  },
  projects: "Projekte",
  add: "Hinzufügen",
  trees: "Bäume",
  tree: "Baum",
  choose_tree: "Wählen Sie einen Baum aus",
  customers: "Kund:innen",
  customer: "Kund:in",
  tasks: "Aufgaben",
  task_suggestions_title: "Empfohlene Aufgaben",
  task_suggestions_empty: "Keine offenen Empfehlungen.",
  task_suggestions_pending_count: "offene Empfehlungen",
  task_suggestions_open_page: "Empfehlungen öffnen",
  task_suggestion_create_task: "Aufgabe erstellen",
  task_suggestion_dismiss: "Verwerfen",
  task_suggestion_bulk_create: "Auswahl erstellen",
  task_suggestion_bulk_dismiss: "Auswahl verwerfen",
  task_suggestion_bulk_created_success: "Ausgewählte Empfehlungen erstellt.",
  task_suggestion_bulk_dismissed_success: "Ausgewählte Empfehlungen verworfen.",
  task_suggestion_created: "Erstellt",
  task_suggestion_created_success: "Aufgabe aus Empfehlung erstellt.",
  task_suggestion_dismissed_success: "Empfehlung verworfen.",
  task_suggestion_health_red: "Rot",
  task_suggestion_health_yellow: "Gelb",
  task_suggestion_reason_fallback: "Gesundheitszustand auffällig.",
  task_suggestion_choose_assignee_title: "Zuständige Person auswählen",
  task_suggestion_choose_assignee_body:
    "Wählen Sie, wem die Bewässerungsaufgabe bei der Annahme dieses Vorschlags zugewiesen wird.",
  task_suggestion_choose_assignee_validation: "Bitte eine Person auswählen.",
  task_suggestion_bulk_manual_only:
    "Im manuellen Modus können Bewässerungsvorschläge nur einzeln angenommen werden.",
  select_all: "Alle auswählen",
  deselect_all: "Auswahl aufheben",
  clear: "Zurücksetzen",
  with_sensor: "Mit Sensor",
  without_sensor: "Ohne Sensor",
  active_installation: "Aktive Installation",
  no_installation: "Keine Installation",
  filter_by_location: "Nach Standort filtern",
  active_sensor_installation: "Aktive Sensorinstallation",
  irrigation_settings: "Bewässerung",
  irrigation_trigger_conditions: "Trigger-Bedingungen",
  irrigation_trigger_yellow: "Auslösen bei Gesundheitsstatus Gelb",
  irrigation_trigger_red: "Auslösen bei Gesundheitsstatus Rot",
  irrigation_trigger_after_days: "Auslösen nach X Tagen",
  irrigation_auto_create_task: "Aufgabe automatisch erstellen (ohne Empfehlung)",
  irrigation_suggestion_assignment_mode_title: "Zuständigkeit für Vorschläge",
  irrigation_suggestion_assignment_mode_hint:
    "Wählen Sie, ob Bewässerungsvorschläge mit der Standardperson pro Standort übernommen werden oder die zuständige Person bei jeder Annahme manuell ausgewählt wird.",
  irrigation_suggestion_assignment_mode_area_default: "Standard zuständige Person pro Standort",
  irrigation_suggestion_assignment_mode_manual:
    "Zuständige Person bei jeder Annahme manuell auswählen",
  irrigation_default_volumes: "Standard-Bewässerungsmengen",
  development_phase: "Entwicklungsphase",
  irrigation_phase_default: "Keine Phase (Standard)",
  default_liters: "Standard Liter",
  irrigation_interval_title: "Bewässerungsintervall",
  irrigation_interval_daily: "Täglich",
  irrigation_interval_weekly: "Wöchentlich",
  irrigation_interval_biweekly: "Alle 2 Wochen",
  irrigation_interval_custom: "Benutzerdefiniert (X Tage)",
  irrigation_repeat_every: "Wiederhole alle",
  irrigation_stop_condition_title: "Stopp-Bedingung",
  irrigation_stop_until_green: "Fortsetzen bis Gesundheitsstatus wieder Grün ist",
  irrigation_stop_fixed_cycles: "Feste Anzahl an Zyklen",
  irrigation_cycle_count_label: "Anzahl der Bewässerungszyklen",
  irrigation_area_assignees_title: "Verantwortliche pro Standort",
  irrigation_area_assignees_hint:
    "Legen Sie pro Standort fest, wem automatisch erzeugte oder vorbereitete Bewässerungsaufgaben standardmäßig zugewiesen werden.",
  irrigation_no_areas: "Keine Standorte verfügbar.",
  save_settings: "Einstellungen speichern",
  irrigation_settings_saved: "Bewässerungseinstellungen gespeichert.",
  irrigation_validation_custom_days: "Bitte geben Sie ein gueltiges Intervall in Tagen an.",
  irrigation_validation_fixed_cycles: "Bitte geben Sie eine gueltige Anzahl Zyklen an.",
  files_selected: "Dateien ausgewählt",
  past_tasks: "Vergangene",
  future_tasks: "Zukünftige",
  tree_phases: "Baumphasen",
  health_states_title: "Gesundheitsstatus",
  task: "Aufgabe",
  add_task: "Aufgabe hinzufügen",
  edit_task: "Aufgabe bearbeiten",
  task_details: "Aufgabendetails",
  select_task_types: "Aufgabentypen auswählen",
  print_tree_tag: "Baumetikett drucken",
  tree_photos: "Baumfotos",
  leaf_photos: "Blattfotos",
  confirm_delete_image: "Sind Sie sicher, dass Sie dieses Bild löschen möchten?",
  data_science: "Datenanalyse",
  map_view: "Kartenansicht",
  map_add_tree_mode: "Positionierungsmodus aktiv",
  map_add_tree_hint: "Bewegen Sie die Karte, um die Baumposition festzulegen.",
  select_project: "Projekt auswählen",
  choose_project: "Wählen Sie ein Projekt",
  please_select_project: "Bitte wählen Sie ein Projekt aus, um Daten anzuzeigen",
  please_select_project_to_view_map: "Bitte wählen Sie ein Projekt aus, um die Karte anzuzeigen",
  ds_fetch_error_message:
    "Die ausgewählten Zeitreihendaten konnten nicht geladen werden. Der gewählte Zeitraum oder die Anzahl der Sensoren ist möglicherweise zu groß.",
  ds_fetch_error_hint:
    "Bitte reduzieren Sie den Datumsbereich, wählen Sie weniger Sensoren aus oder versuchen Sie es erneut.",
  ds_pending_reload_message:
    "Das Diagramm ist ausgeblendet, weil sich Ihre Auswahl geändert hat und die Daten noch nicht neu geladen wurden.",
  ds_pending_reload_hint: 'Klicken Sie auf "Load Data", um das Diagramm zu aktualisieren.',
  ds_no_data_message: "Keine Daten verfügbar",
  ds_no_data_hint:
    "Für die ausgewählten Filter und den gewählten Zeitraum wurden keine Werte gefunden.",
  ds_enter_fullscreen: "Fokusmodus",
  ds_exit_fullscreen: "Fokusmodus beenden",
  no_project_selected: "Kein Projekt ausgewählt",
  show_tree_list: "Baumliste anzeigen",
  show_all_trees: "Alle Bäume anzeigen",
  all_trees: "Alle Bäume",
  no_trees_found: "Keine Bäume gefunden",
  confirm: "Bestätigen",
  health_state: "Baumstatus",
  last_value: "Letzter Messwert",
  weather: "Wetter",
  project_details: {
    empty_project: "Leeres Projekt, bitte beginnen Sie mit dem Hinzufügen von Bäumen.",
    empty_trees: "Keine Bäume erstellt, beginnen Sie bitte mit dem Hinzufügen von Bäumen.",
    no_tree_selected: "Bitte Baum auswählen, um Details anzuzeigen",
    no_sensor_selected: "Bitte Sensor auswählen, um Details anzuzeigen",
    empty_sensors: "Keine Sensoren erstellt, beginnen Sie mit dem Hinzufügen von Sensoren.",
    no_area_selected: "Bitte Bereich auswählen, um Details anzuzeigen",
  },
  user_details: {
    empty_project: "Kein Benutzer, bitte beginnen Sie mit dem Hinzufügen von Bäumen.",
    no_user_selected: "Bitte Benutzer auswählen, um Details anzuzeigen",
  },
  sensor_details: {
    empty_sensors: "Kein Sensor, bitte beginnen Sie mit dem Hinzufügen von Sensoren.",
    no_sensor_selected: "Bitte Sensor auswählen, um Details anzuzeigen",
    no_data_found: "Keine Sensordaten gefunden",
    no_recent_measurements: "Keine Messwerte in den letzten 3 Monaten.",
    no_recent_measurements_hint:
      "Um ältere Daten zu prüfen, nutzen Sie die Datenanalyse und passen Sie den Zeitraum an.",
    no_evaluation_possible: "Keine Auswertung möglich.",
  },
  sensor: "Sensor",
  sensors: "Sensoren",
  sensor_data: "Sensordaten",
  species: "Art",
  genus: "Gattung",
  actions: "Aktionen",
  battery: "Batterie",
  threshold: "Grenzwert",
  settings: "Einstellungen",
  tour_start: "Tour starten",
  help: "Hilfe",
  feedback: "Feedback",
  api_documentation: "API-Dokumentation",
  wiki_help: "Wiki & Anleitungen",
  without_project: "Ohne Projekt",
  without_location: "Ohne Standort",
  no_projects_available: "Keine Projekte verfügbar",
  reporting: "Reporting",
  feedback_problem_url: "Problem-URL",
  feedback_category: "Kategorie",
  feedback_category_bug: "Fehlerbericht",
  feedback_category_positive: "Positives Feedback",
  feedback_category_feature_request: "Feature-Wunsch",
  feedback_priority: "Dringlichkeit",
  feedback_priority_low: "Niedrig",
  feedback_priority_medium: "Mittel",
  feedback_priority_high: "Hoch",
  feedback_priority_critical: "Kritisch",
  feedback_screenshot: "Screenshot",
  feedback_description: "Beschreibung",
  send_feedback: "Feedback senden",
  feedback_submit_success: "Feedback wurde erfolgreich gespeichert.",
  download_excel: "Excel herunterladen",
  download_pdf: "PDF herunterladen",
  download_csv: "CSV herunterladen",
  report_date: "Datum",
  report_sensor_tab: "Sensor Report",
  report_kataster_tab: "Kataster Report",
  report_effect_tab: "Wirkungsreport",
  report_range_1w: "1 Woche",
  report_range_1m: "1 Monat",
  report_range_3m: "3 Monate",
  report_range_1y: "1 Jahr",
  all_areas: "Alle Standorte",
  all_species: "Alle Baumarten",
  all_responsible: "Alle Verantwortlichen",
  report_total_active_sensors: "Aktive Sensoren",
  report_offline_sensors: "Offline Sensoren",
  report_avg_moisture_index: "Durchschnittlicher Feuchteindex",
  report_critical_trees: "Kritische Bäume",
  report_batteries_low: "Batterien < 20%",
  report_threshold_violations: "Schwellenwertverletzungen",
  report_avg_moisture_over_time: "Feuchteindex im Zeitverlauf",
  report_health_distribution: "Verteilung Gesundheitsstatus",
  report_rain_vs_index: "Regen vs. Feuchteindex",
  report_violations: "Verletzungen",
  report_total_trees: "Anzahl Bäume",
  report_controls_performed: "Durchgeführte Kontrollen",
  report_overdue_tasks: "Überfällige Aufgaben",
  report_completed_tasks: "Abgeschlossene Aufgaben",
  report_documented_maintenance: "Dokumentierte Maßnahmen",
  report_avg_control_interval: "Durchschnittliches Kontrollintervall",
  report_task_status_distribution: "Aufgabenstatus-Verteilung",
  report_controls_per_month: "Kontrollen pro Monat",
  report_maintenance_type_distribution: "Verteilung Maßnahmentypen",
  report_critical_with_open_task: "Kritische Bäume mit offener Aufgabe",
  report_avg_violation_to_completion: "Ø Zeit von Verletzung bis Abschluss",
  report_index_change_after_irrigation: "Indexänderung nach Bewässerung",
  report_index_change_after_pruning: "Indexänderung nach Schnitt",
  report_before_after_analysis: "Vorher/Nachher-Analyse",
  report_before: "Vorher",
  report_after: "Nachher",
  report_irrigation_vs_index: "Bewässerungen vs. Feuchteindex",
  report_critical_vs_completed: "Kritische Bäume vs. abgeschlossene Maßnahmen",
  due_date: "Fällig am",
  reason: "Grund",
  impact: "Wirkung",
  rainfall: "Niederschlag",
  index: "Index",
  completed: "Abgeschlossen",
  notifications: "Benachrichtigungen",
  mark_all_as_seen: "Markiere alle als gelesen.",
  showing: "Anzeigen",
  hardware_serial: "DevEUI",
  hardware_serial_imei: "DevEUI/IMEI",
  hardware_serial_imei_description:
    "Die eindeutige Identifikation des Sensors. Sie befindet sich auf dem Aufkleber auf dem Sendemodul. Für LoRaWAN Sensoren handelt es sich um die DevEUI und für NB-IoT Sensoren um die IMEI.",
  dev_eui: "DevEUI",
  imei: "IMEI",
  add_sensor: "Sensor hinzufügen",
  add_user: "Benutzer hinzufügen",
  edit_user: "Benutzer bearbeiten",
  edit_customer: "Kunden bearbeiten",
  edit_sensor: "Sensor bearbeiten",
  push_message_notification: "Push-Benachrichtigungen",
  email_notification: "E-Mail-Benachrichtigungen",
  email_schedule: "E-Mail-Zeitplan",
  weekly_summary_email: "Wöchentliche Zusammenfassung per E-Mail",
  daily_changes_email: "Tägliche Änderungs-E-Mail",
  manage_users_description: "Benutzerkonten und Berechtigungen verwalten",
  manage_customers_description: "Kundeninformationen und Zugriff verwalten",
  statistics: "Statistiken",
  customer_statistics_description: "Kundenstatistiken und Datenübersicht anzeigen",
  go_to_users: "Zu Benutzern gehen",
  go_to_customers: "Zu Kunden gehen",
  tree_with_sensor: "Baum mit Sensor",
  represented_tree: "Repräsentierter Baum",
  tree_without_sensor: "Baum ohne Sensor",
  sensor_status_change_to_no_connection: "Sensorstatusänderung: Grau/kein Datenempfang",
  sensor_status_change_to_dry: "Sensorstatusänderung: Rot/Trockenstress",
  sensor_status_change_to_drying_out: "Sensorstatusänderung: Gelb/Leichter Trockenstress",
  treespecies: "Baumart",
  treegenus: "Baumgattung",
  skip: "Überspringen",
  notes: "Anmerkungen",
  latitude: "Breitengrad",
  longitude: "Längengrad",
  trunk_circumference: "Stammumfang",
  planting_year: "Pflanzjahr",
  select_year: "Jahr auswählen",
  crown_diameter: "Kronendurchmesser",
  represent_tree: "Baum darstellen",
  planting_time: "Pflanzzeit",
  altitude: "Höhe",
  height: "Höhe",
  location: "Standort",
  reference: "Referenz",
  invalid_date: "Ungültiges Datum",
  error: {
    this_field_is_required: "Dieses Feld ist erforderlich",
    name_field_is_required: "Namensfeld ist erforderlich",
    please_choose_species: "Bitte die Baumart auswählen",
    please_choose_genus: "Bitte die Baumattung auswählen",
    choose_location: "Standort wählen",
    hardware_serial_no_is_required: "Die Hardware-Seriennummer ist erforderlich",
    a_valid_threshold_is_required: "Ein gültiger Schwellenwert ist erforderlich",
    form: "Die Eingabe der Werte war fehlerhaft. Bitte korrigieren Sie diese und versuchen es erneut.",
    something_went_wrong: "Etwas ist schiefgelaufen",
    loading_customers: "Fehler beim Laden der Kunden",
    loading_trees: "Fehler beim Laden der Bäume",
    loading_users: "Fehler beim Laden der Benutzer",
  },
  first_name: "Vorname",
  last_name: "Nachname",
  profile: "Profil",
  Manual: "Benutzerhandbuch",
  of: "von",
  the: "der",
  Menu: "Menü",
  phone_number: "Telefonnummer",
  account_type: "Kontotyp",
  city: "Stadt",
  street_name: "Straße",
  house_number: "Hausnummer",
  country: "Land",
  zip_code: "Postleitzahl",
  day: {
    mon: "Montag",
    tue: "Dienstag",
    wed: "Mittwoch",
    thu: "Donnerstag",
    fri: "Freitag",
    sat: "Samstag",
    sun: "Sonntag",
  },
  end: "Enddatum",
  admin: "Admin",
  basic: "Basis",
  superuser: "Superuser",
  add_existing_tree: "Vorhandenen Baum hinzufügen",
  phase: "Phase",
  Youngphase: "Jugendphase",
  Oldphase: "Alterungsphase",
  Midphase: "Reifephase",
  select_phase: "Phase auswählen",
  health_states: {
    wet: "Zu nass",
    wet_todo: "Der Baum oder Boden scheint zu nass zu sein und sollte nicht bewässert werden.",
    healthy: "Kein Trockenstress",
    healthy_todo: "Sie müssen nichts unternehmen.",
    medium: "Mittel",
    critical: "Kritisch",
    frost: "Frost",
    frost_todo: "Der Baum könnte Frostschäden haben.",
    dry: "Trocken",
    dry_todo: "Der Baum muss schnellstmöglich bewässert oder überprüft werden.",
    disconnect: "Verbindung trennen",
    drying_out: "Am Austrocknen",
    drying_out_todo: "Der Baum sollte bewässert werden.",
    too_wet: "Zu nass",
    too_wet_todo: "Der Baum oder Boden scheint zu nass zu sein und sollte nicht bewässert werden.",
    unknown: "Unbekannt",
    unknown_todo: "Der Sensor sollte überprüft werden.",
    no_sensor: "Kein Sensor",
    no_sensor_todo:
      "Kein Sensor installiert. Installieren Sie einen Sensor zur Überwachung des Trockenstresses.",
    no_data: "Keine Daten",
    no_data_todo: "Sensor ist installiert, sendet aber keine Daten. Sensorverbindung prüfen.",
    maintenance_needed: "Sensor misst unplausible Werte",
    maintenance_needed_todo: "Sensorwerte erscheinen unplausibel. Sensor überprüfen und warten.",
    priority_title: "Wie wird der Status berechnet?",
    priority_explanation: "Der Gesundheitszustand basiert auf einer Priorität:",
    priority_1_crown: "Kronensensoren (wenn vorhanden, nur diese)",
    priority_2_soil: "Bodensensoren (nur wenn keine Kronensensoren)",
    priority_3_dendrometer: "Dendrometer (nur wenn keine anderen)",
    priority_note:
      "💡 In der Detailansicht sehen Sie alle Sensoren. Der Baumstatus wird aber nur von der höchsten verfügbaren Priorität bestimmt.",
    soil_needs_attention: "Bodensensoren zeigen kritische Werte, obwohl die Krone gesund ist",
    mixed_sensors: "Sensoren zeigen unterschiedliche Zustände",
    status_from_crown:
      "Status basiert auf Kronensensor: {{crownStatus}}\n(Bodensensor: {{soilStatus}} - nur zur Info)",
    status_from_soil: "Status basiert auf Bodensensor (keine Kronensensoren vorhanden)",
    determines_tree_status: "Dieser Sensor bestimmt den Baumstatus",
    info_only: "Nur zur Information, bestimmt nicht den Baumstatus",
  },
  tree_water_stress: "Trockenstress",
  tree_status: "Baumstatus",
  tree_cadastre_no: "Baumkataster Nr.",
  crown: "Krone",
  soil: "Boden",
  overall: "Gesamt",
  health_overview: "Gesundheitsübersicht",
  health_priority: "Priorität",
  note: "Hinweis",
  active: "aktiv",
  defect_sensor: "Defekter Sensor vorhanden",
  defect_sensors_excluded: "Defekte Sensoren werden von der Berechnung ausgeschlossen",
  defect_sensors_info:
    "Defekte oder nicht erreichbare Sensoren (grau dargestellt) werden bei der Gesundheitsberechnung nicht berücksichtigt. Nur funktionierende Sensoren fließen in den Status ein.",
  export: "Exportieren",
  export_data: "Daten exportieren",
  export_tasks: "Aufgaben exportieren",
  export_irrigation_tasks: "Bewässerungsaufgaben exportieren",
  export_irrigation_description:
    "Bewässerungsaufgaben als Excel exportieren. Zeigt alle Einträge der aktuellen Vegetationsperiode (April - Oktober).",
  export_tasks_description:
    "Aufgaben als Excel exportieren. Zeigt erledigte und geplante Aufgaben gruppiert nach Baum.",
  no_data_to_export: "Keine Daten zum Exportieren",
  no_tasks_found: "Keine Aufgaben für die ausgewählten Filter gefunden.",
  problem_in_creating_customer: "Problem beim Anlegen des Kunden",
  problem_in_creating_sensor: "Problem beim Anlegen des Sensors",
  select_customer_type: "Kundentyp wählen",
  assign_to_tree: "dem Baum zuordnen",
  customer_type: "Kundentyp",
  customer_type_agriculture: "Landwirtschaft",
  customer_type_city: "Stadt",
  customer_type_forestry: "Forstwirtschaft",
  customer_type_science: "Wissenschaft",
  import_trees: "Bäume importieren",
  choose_file: "Datei auswählen",
  upload: "Hochladen",
  choose_the_file_to_be_imported: "Zu importierende Datei auswählen",
  upload_tree: "Baum hochladen",
  change_image: "Bild ändern",
  update_image: "Bild aktualisieren",
  update_customer_logo_description: "Laden Sie Ihr Firmenlogo hoch und aktualisieren Sie es",
  tree_added_successfully: "Baum erfolgreich hinzugefügt",
  change_language: "Sprache ändern",
  appearance: "Aussehen",
  theme: "Design",
  theme_description: "Wählen Sie aus, wie TreeSense für Sie aussehen soll",
  theme_light: "Hell",
  theme_light_desc: "Hell und klar",
  theme_dark: "Dunkel",
  theme_dark_desc: "Angenehm für die Augen",
  theme_system: "System",
  theme_system_desc: "Folgt Ihrem Gerät",
  current_theme: "Aktuelles Design",
  language_description: "Wählen Sie Ihre bevorzugte Sprache",
  saved: "Gespeichert",
  total_trees: "Gesamtzahl der Bäume",
  total_trees_species: "Gesamtzahl der Baumarten",
  total_sensors: "Gesamtzahl der Sensoren",
  critical_sensors: "Gesamtzahl der kritischen Sensoren",
  number_of_tree_on_respective_area: "Anzahl der Bäume auf der jeweiligen Fläche",
  number_of_tree_based_on_health_status: "Anzahl der Bäume basierend auf dem Gesundheitszustand",
  time: "Zeit",
  maintainance: "Wartung",
  type_of_maintenance: "Art der Wartung",
  custom_maintenance_type: "Benutzerdefinierte Wartungsart",
  add_your_own_maintenance: "Eigene Wartung hinzufügen",
  disconnected_sensors: "Getrennte Sensoren",
  Set_the_report_of_the_project_with_the_help_of_the_pin:
    "Stellen Sie den Bericht des Projekts mit Hilfe der Stecknadel ein",
  sending: "Senden...",
  Dry: "Trocken",
  Dryingout: "Am Austrocknen",
  Healthy: "Gesund",
  Wet: "Zu Nass",
  Unknown: "Unbekannt",
  write_something: "Schreiben Sie etwas...",
  write_some_notes_on_action_performed:
    "Schreiben Sie einige Notizen zur durchgeführten Aktion ...",
  resistance: "Widerstand",
  water_soil: "Bodenfeuchte",
  dendrometer: "Dendrometer",
  diameter: "Durchmesser",
  irrigation: "Bewässerung",
  crown_care: "Kronenpflege",
  tree_control: "Baumkontrolle",
  ligature_control: "Ligaturkontrolle",
  trunk_protection: "Stammschutz",
  tree_stakes_control: "Baumpfahlkontrolle",
  clearance_profile_pruning: "Schnitt des Lichtraumprofils",
  deadwood_removal: "Totholzentfernung",
  stem_cane_removal: "Stammstockentfernung",
  topiary: "Topiary",
  head_purning: "Kronenschnitt",
  either_fill_all_address_or_make_all_empty:
    "Entweder alle Adressen ausfüllen oder alle leer machen",
  search_area: "Standortsuche",
  search_tree: "Baumsuche",
  search_sensor: "Sensorsuche",
  search_sensors: "Sensoren suchen...",
  search_trees: "Bäume suchen...",
  showing_results: "{{count}} Ergebnisse angezeigt",
  mark_as_Seen: "Als gesehen markieren",
  tick_the_checkbox_to_download_data: "Checkbox ankreuzen, um Daten herunterzuladen",
  download_sensor_data: "Sensordaten herunterladen",
  export_sensor_description:
    "Exportiert die verfügbaren Sensormesswerte für den gewählten Zeitraum.",
  include_advanced_calibration_values: "Erweiterte Kalibrierungs-/Debug-Werte einschließen",
  include_mean_values: "Mittelwerte einschließen",
  include_mean_values_hint: "Fügt gemittelte Werte für den ausgewählten Zeitraum zum Export hinzu.",
  sensor_name: "Sensorname",
  temperature: "Temperatur",
  rain: "Regen",
  loading_data: "Daten werden geladen...",
  align_qr_code_within_the_frame: "QR-Code innerhalb des Rahmens ausrichten",
  gallery: "Galerie",
  scan_to_add_sensor: "Scannen, um Sensor hinzuzufügen",
  choose_qr_to_scan: "QR zum Scannen auswählen",
  pulse_resistance_in_kOhm: "Impulswiderstand in kOhm",
  loading: "Laden ...",
  irrigationArea: "Standorte",
  button: {
    back: "Zurück",
    next: "Weiter",
    save: "Speichern",
    reset: "Zurücksetzen",
    saving: "Speichern ...",
    update: "Aktualisieren",
    updating: "Aktualisieren ...",
    add_tree: "Baum hinzufügen",
    add_sensor: "Sensor hinzufügen",
    import_tree: "Baum importieren",
    add_irrigation_area: "Bewässerungsgebiet hinzufügen",
    add_customer: "Kunde hinzufügen",
    add_all: "Baum mit Sensor erstellen",
    cancel: "Abbrechen",
    edit_customer: "Kunden bearbeiten",
  },
  choose_location: "Ort wählen",
  tree_form: {
    sensors: "Sensoren",
    position: "Position",
    more_info: "Weitere Informationen",
    tree_profile: "Baumprofil",
    representTree: "Untergeordnete Bäume",
    info: {
      represent: {
        heading: "Referenzbaum",
        help: "Wählen Sie den Baum, der diesen Standort für Auswertungen und Berichte repräsentiert.",
        note: "Um die Daten bestmöglich analysieren zu können, empfehlen wir den Upload eines Bildes des Baums und eines aussagekräftigen Blatts zum gleichen Zeitpunkt.",
      },
      sensors: {
        heading: "Sensoren",
        help: "Ordnen Sie die Sensoren zu, die zu diesem Baum gehören.",
        note: "Die ausgewählten Sensoren werden zur Anzeige der Live-Daten und zur Berechnung von Bewässerungsempfehlungen verwendet.",
      },
      soil: {
        heading: "Bodenparameter",
        max_f_help: "Maximaler Sensorwert für gut bewässerte Bäume (F = bewässert).",
        max_f_label: "Maximalwert (bewässerte Bäume)",
        max_nf_help: "Maximaler Sensorwert für nicht bewässerte Bäume (NF = nicht bewässert).",
        max_nf_label: "Maximalwert (nicht bewässerte Bäume)",
        note: "Diese Schwellenwerte werden genutzt, um Bewässerungsempfehlungen und Ampelfarben abzuleiten.",
        pwp_help: "Sensorwert, bei dem der Baum den permanenten Welkepunkt (PWP) erreicht.",
        pwp_label: "Permanenter Welkepunkt (PWP)",
      },
    },
  },
  user_form: {
    profile: "Profil",
    address: "Adresse",
    basic_info: "Grundlegende Informationen",
    login_credentials: "Anmeldedaten",
    areas: "Bewässerungsbereiche",
  },
  sensor_form: {
    name: "Name",
    threshold: "Schwellenwert",
    hardware_serial: "DevEUI/IMEI",
    sensor_type: "Sensortyp",
    network_type: "Netzwerktyp",
  },
  task_form: {
    basic_info: "Grundlegende Informationen",
    assignment: "Zuweisung",
    title: "Titel",
    title_placeholder: "Aufgabentitel eingeben",
    description: "Beschreibung",
    description_placeholder: "Aufgabenbeschreibung eingeben",
    priority: "Priorität",
    priority_low: "Niedrig",
    priority_medium: "Mittel",
    priority_high: "Hoch",
    status: "Status",
    status_pending: "Ausstehend",
    status_in_progress: "In Bearbeitung",
    status_completed: "Abgeschlossen",
    tree: "Baum",
    assigned_to: "Zugewiesen an",
    due_date: "Fälligkeitsdatum",
    created_at: "Erstellt am",
    created_by: "Erstellt von",
    select_task_to_view: "Wählen Sie eine Aufgabe aus, um Details anzuzeigen",
    select_user: "Benutzer auswählen",
  },
  network_type: "Netzwerktyp",
  sensor_type: "Sensortyp",
  lora_wan: "LoRaWAN",
  nb_iot: "NB-IoT",
  area_form: {
    existing_area: "Bestehender Standort",
  },
  add_all_form: {
    title: "Baum mit Sensor in Bereich hinzufügen",
    sensor: {
      title: "Sensor",
      explanation:
        "Hier kann ein neuer Sensor erstellt und dem Baum hinzugefügt werden. Oder aber ein bereits bestehender Sensor kann ausgewählt werden, um ihn dem hinzuzufügen.",
      new_sensor: "Erstelle einen neuen Sensor",
      existing_sensors: "Bestehende Sensoren hinzufügen",
    },
    tree: {
      title: "Baum",
      explanation: "Hier kann ein neuer Baum erstellt oder ein bestehender ausgewählt werden.",
      new_tree: "Erstelle einen neuen Baum",
      existing_tree: "Wähle einen bestehenden Baum aus",
    },
    area: {
      title: "Standort",
      explanation:
        "Hier kann ein neuer Standort erstellt oder ein bestehender ausgewählt werden, welchem der Baum hinzugefügt werden soll.",
      new_area: "Neuen Standort erstellen",
      existing_area: "Bestehenden Standort auswählen",
    },
  },
  new_area: "Neuer Standort",
  existing_area: "Bestehender Standort",
  explanation: "Erklärung",
  create_new_tree: "Neuen Baum erstellen",
  validation: {
    email_is_required: "E-Mail ist erforderlich",
    password_is_required: "Passwort ist erforderlich",
    invalid_email_address: "Ungültige E-Mail-Adresse",
    name_is_required: "Name ist erforderlich",
    hardware_serial_is_required: "Hardware-Seriennummer ist erforderlich",
    user_with_this_email_already_exist: "Benutzer mit dieser E-Mail-Adresse existiert bereits",
    all_address_field_are_required: "Alle Adressfelder sind erforderlich",
    position_is_required: "Position ist erforderlich",
    invalid_house_number: "Ungültige Hausnummer",
    user_limit_exceeded_for_your_package: "Benutzerlimit für Ihr Paket überschritten",
    sensor_limit_exceeded_for_your_package: "Sensorlimit für Ihr Paket überschritten",
    tree_limit_exceeded_for_your_package: "Baumlimit für Ihr Paket überschritten",
    invalid_hex_identifier:
      "Die Kennung muss ein gültiger hexadezimaler Wert in Großbuchstaben sein. Bitte nur Ziffern 0–9 und Großbuchstaben A–F verwenden.",
    imei_must_be_15_digits: "IMEI muss genau 15 Ziffern enthalten.",
    hardware_serial_must_be_16_characters:
      "Die Hardware-Seriennummer muss genau 16 Zeichen lang sein.",
    must_be_a_number: "Der Wert muss eine Zahl sein",
    out_of_range: "Der Wert muss zwischen {{min}} und {{max}} liegen",
    task_error: "Aufgabe ist erforderlich.",
    cadastre_or_name_required: "Entweder Baumkataster-Nr. oder Baumname muss angegeben werden.",
    either_field_required: "* Mindestens eines dieser Felder ist erforderlich.",
    required_fields: "* Pflichtfelder",
    this_field_is_required: "Dieses Feld ist erforderlich",
    project_name_required: "Projektname ist erforderlich",
    project_name_max_length: "Projektname darf maximal 100 Zeichen lang sein",
    project_start_required: "Projektstart ist erforderlich",
    area_required: "Bereich ist erforderlich",
  },
  drag_the_below_variables_to_graph_area:
    "Ziehen Sie die folgenden Variablen in den Diagrammbereich",
  drop_left: "Drop Left",
  drop_right: "Drop Right",
  drop_the_variable_to_get_data: "Lassen Sie die Variable fallen. Mach weiter!",
  no_data_available_please_check_data_available_to_this_date:
    "Keine Daten verfügbar, bitte überprüfen Sie die bis zu diesem Datum verfügbaren Daten",
  unable_to_upload_file: "Datei kann nicht hochgeladen werden",
  file_upload_successfully: "Datei wurde erfolgreich hochgeladen",
  no_tree_is_selected: "Kein Baum ausgewählt",
  no_sensor_is_selected: "Kein Sensor ausgewählt",
  areaName: "Name",
  childTree: "Untergeordneter Baum",
  add_child_tree: "Untergeordneten Baum hinzufügen",
  parentTree: "Übergeordneter Baum",
  area: "Standort",
  areas: "Standorte",
  add_area: "Standort erstellen",
  start_with_adding_new_project: "Beginnen Sie mit dem Hinzufügen eines neuen Projekts",
  resis_temp_comp: "ResisTempComp",
  health_of_tree_is_good: "Gesundheitszustand des Baums ist gut",
  health_of_tree_is_drying_out: "Gesundheit des Baums trocknet aus",
  health_of_tree_is_poor: "Gesundheit des Baums ist schlecht",
  sensor_disconnect: "Sensor getrennt",
  battery_full: "Batterie voll",
  battery_empty: "Batterie leer",
  maintenance_needed: "Sensor misst unplausible Werte",
  All: "Alle",
  less_than_60_of_the_battery_remaining: "Weniger als 60 % der verbleibenden Batterie",
  battery_is_getting_low: "Batterie wird schwach",
  size: "Größe",
  type: "Typ",
  records: "Aufzeichnungen",
  pagination_out_of: "von",
  status: "Status",
  tree_count: "Anzahl Bäume",
  welcome_back: "Willkommen zurück!",
  looks_like_you_dont_have_selected_area_please_select_the_area_to_get_data:
    "Sieht so aus, als hätten Sie keinen ausgewählten Bereich. Bitte wählen Sie einen Bereich aus, um Daten zu erhalten.",
  looks_like_you_dont_have_selected_tree_please_select_a_tree_to_get_data:
    "Sieht so aus, als hätten Sie keinen Baum ausgewählt. Bitte wählen Sie einen Baum aus, um Daten zu erhalten.",
  looks_like_you_dont_have_selected_sensor_please_select_a_sensor_to_get_data:
    "Sieht so aus, als hätten Sie keinen ausgewählten Sensor. Bitte wählen Sie einen Sensor aus, um Daten abzurufen.",
  please_drag_the_variable_to_display_data: "Bitte ziehen Sie die Variable, um Daten anzuzeigen.",
  click_on_marker_to_select_tree: "Marker anklicken, um Baum auszuwählen",
  next_irrigation: "Nächste Bewässerung",
  mean: "Mittelwert",
  default: "Standard",
  default_legacy: "Standart, alt",
  sensor_state: "Sensorstatus",
  state: "Status",
  moisture_content: "Treesense Feuchtigkeitsindex",
  drought_days: "Trockentage",
  formula_type: "Formel",
  calibration_species: "Kalibrierungsart",
  calibration_species_tooltip:
    "Das Kalibrierungsmodell, das für diese Art zur Berechnung des Feuchtigkeitsindexes verwendet wird",
  calibration_species_no_mapping: "Kein Baumarten-Mapping verfügbar",
  calibration_species_unknown_tree_species: "Baumart fehlt",
  calibration_species_legacy_settings_hint:
    "Es wird die alte Kalibrierung der Schwarzpappel verwendet.",
  calibration_species_settings_hint:
    "Wenn hier kein Mapping angezeigt wird oder noch die alte Formel aktiv ist, kann dies unter Einstellungen > Kunde > Feuchtigkeitsgehalts-Formel aktualisiert werden.",
  calibration_species_settings_link: "Zu den Einstellungen",
  card_number: "Kartennummer",
  card_name: "Kartenname",
  expiration_date: "Ablaufdatum",
  continue: "Weiter",
  today: "Heute",
  tomorrow: "Morgen",
  days_left: "noch Tage",
  days: "Tage",
  personal_data: "Persönliche Daten",
  basic_user_projects_hint:
    "Hier können ganze Projekte zugewiesen werden. Alle zugehörigen Standorte/Bereiche der gewählten Projekte werden übernommen.",
  basic_user_areas_hint:
    "Basic-Nutzer:innen sollten einem oder mehreren Standorten zugewiesen werden. Ohne Zuweisungen ist ihr Datenzugriff eingeschränkt.",
  user_invitation_email_hint:
    "Nach dem Speichern erhält der Nutzer eine E-Mail, um sein Passwort selbst zu setzen.",
  persona_labels: {
    tree_inspector: "Bauminspektor:in",
    irrigation_team: "Bewässerungsteam",
    city_tree_manager: "Städtische:r Baummanager:in",
    research_partner: "Forschungspartner:in",
    treesense_support: "TreeSense Support",
  },
  settings_user_info: {
    persona_section_title: "Was sich in der UI ändert",
    role_section_title: "Was sich im Zugriff ändert",
    persona_footer:
      "Personas steuern den Standard-Einstiegspunkt und den UX-Fokus. Die effektiven Rechte kommen weiterhin aus den Backend-Rollenrechten.",
    role_footer:
      "Rollen bestimmen die effektiven Berechtigungen. Personas beeinflussen nur Standard-Navigation und UX-Fokus.",
    persona: {
      tree_inspector: {
        description:
          "UX-Profil für Nutzer:innen, die hauptsächlich im Baumkataster arbeiten und Inspektionen im Feld durchführen.",
        changes: ["Standardseite: Baumkataster", "Fokus: Inspektionen, Baumdaten und Feldarbeit"],
      },
      irrigation_team: {
        description:
          "UX-Profil für Nutzer:innen, die vor allem in aufgabengetriebenen Bewässerungs- und Ausführungsprozessen arbeiten.",
        changes: ["Standardseite: Aufgaben", "Fokus: Bewässerungsabläufe und operative Ausführung"],
      },
      city_tree_manager: {
        description:
          "UX-Profil für Nutzer:innen, die einen Management-Überblick über Dashboard, Kataster und Analysen brauchen.",
        changes: [
          "Standardseite: Dashboard",
          "Fokus: Überblick, Kataster und reporting-nahe Arbeit",
        ],
      },
      research_partner: {
        description:
          "UX-Profil für Nutzer:innen, die hauptsächlich in Data Science und sensorbasierter Analyse arbeiten.",
        changes: ["Standardseite: Data Science", "Fokus: Exploration, Sensordaten und Analysen"],
      },
      treesense_support: {
        description:
          "UX-Profil für Nutzer:innen, die Sensoren überwachen und technische Support-Prozesse bearbeiten.",
        changes: [
          "Standardseite: Sensoren",
          "Fokus: Sensorstatus und technische Support-Workflows",
        ],
      },
    },
    role: {
      superuser: {
        description:
          "Vollständige administrative Rolle mit uneingeschränktem Zugriff auf Konfigurations- und Verwaltungsbereiche.",
        changes: [
          "Kann Benutzer, Einstellungen und kundenbezogene Administration verwalten",
          "Hat typischerweise den breitesten Zugriff über die Module hinweg",
        ],
      },
      admin: {
        description:
          "Administrative Rolle für kundenbezogene Verwaltung und organisatorische Abläufe.",
        changes: [
          "Kann organisatorische Abläufe verwalten, ohne volle Plattformverantwortung zu haben",
          "Hat abhängig von den Backend-Rechten meist breiten Zugriff auf Kundenebene",
        ],
      },
      basic: {
        description:
          "Operative Endnutzer-Rolle für die tägliche Arbeit in zugewiesenen Projekten und Bereichen.",
        changes: [
          "Arbeitet innerhalb zugewiesener Projekte und Bereiche",
          "Bereichszuweisungen sind besonders relevant für den operativen Zugriff",
        ],
      },
    },
  },
  language: "Sprache",
  change_logo: "Logo ändern",
  role: "Rolle",
  demo_project_warning: {
    title: "Demo Account",
    description:
      "Sie nutzen gerade einen Demo Account und haben nur wenige Rechte.\nWenn Sie bereits Kunde sind und Zugang zu Ihrem Kundenkonto haben möchten, kontaktieren Sie bitte den Support: support@treesense.net.\nFalls Sie noch kein Kunde sind, können Sie über unseren Shop auf https://www.treesense.net Sensoren bestellen.",
  },
  add_tree_img: "Baumbilder hochladen",
  datetime_photo: "Aufnahmezeitpunkt des Bilds",
  upload_tree_img: "Baumbild hochladen",
  upload_leaf_img: "Blattbild hochladen",
  upload_3d_model: "3D-Modell hochladen",
  replace_3d_model: "3D-Modell ersetzen",
  remove_3d_model: "3D-Modell entfernen",
  pulse_sensor: "Kronensensor",
  soil_moisture_sensor: "Bodenfeuchtesensor",
  soil_moisture: "Bodenfeuchte",
  soil_moisture_vg: "Bodenfeuchte (van Genuchten)",
  soil_water_tension_sensor: "Bodensaugsspannungssensor",
  soil_water_tension: "Bodensaugsspannung",
  soil_water_tension_vg: "Bodensaugsspannung (van Genuchten)",
  dendrometer_sensor: "Dendrometer",
  tilt_sensor: "Neigungssensor",
  roll: "Roll",
  pitch: "Pitch",
  views_per_page: "Besuche pro Seite",
  customer_attributes: "Kundenattribute",
  tree_profile: {
    tree_species_knowledge: "Fakten",
    tree_species: "Wissenswertes",
    tree_info: "Bauminformationen",
    learn_more: "Klicken Sie hier, um mehr zu erfahren",
  },
  root_system: {
    UN: "Unbekannt",
    SH: "Flachwurzler",
    DE: "Tiefwurzler",
    HE: "Herzwurzler",
  },
  latin_name: "lat. Name",
  german_name: "dt. Name",
  tree_species: "Baumart",
  depth: "Tiefe",
  root_ball: "Ballen",
  healthy: "Gesund",
  okay: "Okay",
  critical: "Kritisch",
  not_sending: "Sendet nicht",
  working: "Funktioniert",
  unknown: "Unbekannt",
  defect: "Defekt",
  tilt_roll: "Neigung Roll",
  tilt_pitch: "Neigung Pitch",
  tilt_threshold: "Neigungsschwellwert",
  tilt_alarm: "Neigungsalarm",
  tilt_alarm_active: "Aktiv",
  tilt_alarm_inactive: "Kein Alarm",
  tilt_alarm_email: "Neigungsalarm E-Mail",
  task_notification_email: "Aufgabenzuweisung E-Mail",
  tilt_calibrate: "Nullen",
  calibrating: "Kalibrierung läuft...",
  tilt_calibrate_confirm: "Aktuelle Position als Nullpunkt setzen?",
  amount_nodes: "Anzahl Sensorknoten",
  add_installation: "Installation erstellen",
  select_sensor: "Sensor auswählen",
  select_depth: "Tiefe auswählen",
  installed_at: "Datum der Montage",
  removed_at: "Datum der Demontage",
  last_battery: "Letzter Batteriewert",
  characters: "Zeichen",
  maximum_of: "Maximal",
  stop_scanning: "Scannen Beenden",
  last_measurements: "Letzte Messwerte",
  adjust_thresholds_crown: "Grenzwerte für Pulse Feuchtigkeitsindex anpassen",
  adjust_thresholds_soil: "Grenzwerte für Bodensensoren anpassen",
  set_default: "Werte zurücksetzen",
  meaning_measurement: "Bedeutung der Sensorwerte",
  download_tree_list: "Baumliste herunterladen (.xlsx)",
  download_tree_details: "Details der Bäume herunterladen (.pdf)",
  not_provided: "Nicht eingetragen",
  soil_moisture_edit: "Grenzwerte vol. Bodenfeuchte",
  soil_water_tension_edit: "Grenzwerte Bodensaugspannung",
  select_language: "Sprache Auswählen",
  hardware_serial_no: "DevEUI",
  required_information: "* Erforderliche Informationen",
  download_project_data: "Alle Sensordaten des Projekts herunterladen",
  download_project_csv: "Projektdaten herunterladen (tsv-Dateien)",
  include_calculated_values: "Berechnete Werte herunterladen",
  calculated_values_wip:
    "Die Berechneten Werte (moisture_content, resis_temp_comp) werden momentan angepasst und sollten generell nicht als Messwerte, sondern als Interpretationshilfe verstanden werden.",
  last_10_measurements: "Letzte 10 Messwerte",
  soil_name: "Bodenname",
  optional_soil_name: "Optionaler Bodenname",
  tree_name: "Baum",
  permanent_wilting_point: "Permanenter Welkepunkt",
  effective_field_capacity: "Nutzbare Feldkapazität",
  field_capacity: "Feldkapazität",
  sensor_status: "Sensor Status",
  sensor_status_description:
    "Der Sensor Status gibt an, ob der Sensor funktioniert oder ob er bspw. gewartet werden muss.",
  variables: "Variablen/Werte",
  timeframe: "Zeitraum",
  timeframe_hint:
    "Unverändert lassen, um die letzten 30 Tage herunterzuladen. Passe den Zeitraum an, um den Export einzuschränken.",
  include_new_moisture_content_data: "Neuen Feuchtigkeitsindex einschließen (species mapping)",
  include_old_moisture_content_data: "Alten Feuchtigkeitsindex einschließen (Schwarzpappel)",
  include_species_mapping_data: "Zusätzlich species-mapping Kalibrierungsdaten einschließen",
  file_download_success: "Datei wurde erfolgreich heruntergeladen.",
  export_failed: "Export fehlgeschlagen. Bitte versuchen Sie es erneut.",
  no_data_for_selected_range:
    "Keine Daten für den gewählten Zeitraum und die ausgewählten Parameter verfügbar.",
  invalid_date_range: "Das Startdatum muss vor dem Enddatum liegen.",
  one_year: "1 Jahr",
  six_months: "6 Monate",
  three_weeks: "3 Wochen",
  one_week: "1 Woche",
  one_day: "1 Tag",
  custom_range: "Eigener Bereich",
  open_time_controls: "Zeitsteuerung öffnen",
  close_time_controls: "Zeitsteuerung schließen",
  filters: "Filter",
  time_range_selection: "Zeitraumauswahl",
  time_range_info:
    "Wählen Sie einen Zeitraum aus, um historische Daten anzuzeigen. Wählen Sie aus voreingestellten Bereichen oder definieren Sie einen benutzerdefinierten Zeitraum.",
  one_year_info: "Daten der letzten 12 Monate anzeigen",
  six_months_info: "Daten der letzten 6 Monate anzeigen",
  three_weeks_info: "Daten der letzten 3 Wochen anzeigen",
  one_week_info: "Daten der letzten 7 Tage anzeigen",
  one_day_info: "Daten der letzten 24 Stunden anzeigen",
  custom_range_info: "Benutzerdefinierten Datums- und Zeitbereich auswählen",
  reset_chart: "Diagramm zurücksetzen",
  reset_info: "Alle Diagrammeinstellungen auf Standard zurücksetzen",
  interval_settings: "Intervall",
  data_interval_settings: "Datenintervall-Einstellungen",
  data_interval_description: "Legen Sie fest, wie Datenpunkte im Diagramm gruppiert werden sollen.",
  close: "Schließen",
  traffic_safety_assessments: "Verkehrssicherheitsprüfungen",
  add_assessment: "Prüfung hinzufügen",
  edit_safety_assessment: "Sicherheitsprüfung bearbeiten",
  add_safety_assessment: "Sicherheitsprüfung hinzufügen",
  no_safety_assessments: "Keine Sicherheitsprüfungen erfasst",
  traffic_safety_status: "Verkehrssicherheitsstatus",
  defect_types: "Schadenarten",
  structural_defects: "Statische Mängel",
  root_defects: "Wurzelschäden",
  trunk_defects: "Stammschäden",
  crown_defects: "Kronenschäden",
  fungal_infection: "Pilzbefall",
  pest_infestation: "Schädlingsbefall",
  safety_status: {
    safe: "Sicher",
    monitoring_required: "Beobachtung erforderlich",
    action_required: "Maßnahmen erforderlich",
    unsafe: "Unsicher",
  },
  risk_level: {
    low: "Geringes Risiko",
    medium: "Mittleres Risiko",
    high: "Hohes Risiko",
    critical: "Kritisches Risiko",
  },
  vta_assessments: "VTA-Untersuchungen",
  add_vta: "VTA hinzufügen",
  edit_vta: "VTA bearbeiten",
  no_vta_assessments: "Keine VTA-Untersuchungen erfasst",
  assessor: "Gutachter",
  vitality_stage: "Vitalitätsstufe",
  vitality_stage_help: "0 = Vital, 1 = Leicht geschwächt, 2 = Geschwächt, 3 = Stark geschwächt",
  crown_vitality: "Kronenvitalität",
  dieback: "Totholz",
  damage_severity_label: "Schadensgrad",
  bark_condition_label: "Rindenzustand",
  growth_rate_label: "Wuchsleistung",
  damage_severity: {
    none: "Keine",
    light: "Leicht",
    moderate: "Mäßig",
    severe: "Schwer",
    critical: "Kritisch",
  },
  bark_condition: {
    healthy: "Gesund",
    minor_damage: "Leichte Schäden",
    moderate_damage: "Mäßige Schäden",
    severe_damage: "Schwere Schäden",
  },
  foliage_density: {
    full: "Voll",
    moderate: "Mäßig",
    sparse: "Licht",
    very_sparse: "Sehr licht",
  },
  growth_rate: {
    vigorous: "Stark",
    normal: "Normal",
    slow: "Schwach",
    stagnant: "Stagnierend",
  },
  inspections: "Kontrollen",
  add_inspection: "Kontrolle hinzufügen",
  edit_inspection: "Kontrolle bearbeiten",
  no_inspections: "Keine Kontrollen erfasst",
  inspection_date: "Kontrolldatum",
  inspection_type_label: "Kontrollart",
  inspection_result_label: "Kontrollergebnis",
  findings: "Feststellungen",
  action_required: "Maßnahmen erforderlich",
  action_priority: "Maßnahmenpriorität",
  next_inspection: "Nächste Kontrolle",
  overdue: "Überfällig",
  inspection_type: {
    routine: "Regelkontrolle",
    safety: "Sicherheitskontrolle",
    detailed: "Eingehende Untersuchung",
    emergency: "Notfallkontrolle",
    post_storm: "Sturmschadenskontrolle",
  },
  inspection_result: {
    passed: "Bestanden",
    passed_with_notes: "Bestanden mit Anmerkungen",
    failed: "Nicht bestanden",
  },
  priority: {
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    urgent: "Dringend",
  },
  tree_info: "Bauminformationen",
  photos: "Fotos",
  no_photos: "Keine Fotos hochgeladen",
  add_photo: "Foto hinzufügen",
  all_projects: "Alle Projekte",
  favorites: "Favoriten",
  new_project: "Neues Projekt",
  trees_short: "Bäume",
  tree_cadastre: "Baumkataster",
  sensors_monitoring: "Sensorik",
  tasks_workflows: "Aufgaben",
  reports_analysis: "Analysen & Berichte",
  new_task: "Neue Aufgabe",
  search_tasks: "Aufgaben durchsuchen...",
  filter_tasks: "Filter",
  reset_filters: "Alle zurücksetzen",
  task_filter_measure_type: "Aufgabentyp",
  task_filter_pruning_type: "Schnittart",
  task_filter_due_period: "Zeitraum",
  task_filter_today: "Heute",
  task_filter_this_week: "Diese Woche",
  task_filter_this_month: "Diesen Monat",
  task_filter_overdue: "Überfällig",
  measure_type_inspection: "Regelkontrolle",
  measure_type_irrigation: "Bewässerung",
  measure_type_pruning: "Schnittmaßnahme",
  measure_type_sensor_maintenance: "Sensorwartung",
  measure_type_soil_maintenance: "Bodenpflege",
  measure_type_free_entry: "Freie Eintragung",
  view_kanban: "Kanban",
  view_list: "Liste",
  view_calendar: "Kalender",
  stats_total: "Gesamtaufgaben",
  stats_in_progress: "In Bearbeitung",
  stats_completed: "Abgeschlossen",
  stats_overdue: "Überfällig",
  status_planned: "Geplant",
  status_in_progress: "In Bearbeitung",
  status_review: "In Prüfung",
  status_completed: "Abgeschlossen",
  status_GEPLANT: "Geplant",
  status_BEAUFTRAGT: "Beauftragt",
  status_IN_ARBEIT: "In Arbeit",
  status_ERLEDIGT: "Erledigt",
  status_NICHT_GESCHAFFT: "Nicht geschafft",
  priority_low: "Niedrig",
  priority_medium: "Mittel",
  priority_high: "Hoch",
  task_title: "Titel",
  task_title_placeholder: "Titel eingeben",
  task_description: "Beschreibung",
  task_description_placeholder: "Beschreibung eingeben",
  task_assignee: "Zugewiesen an",
  task_assignee_select_placeholder: "Person auswählen",
  task_tree_species: "Baumart",
  task_tree_species_placeholder: "Baumart eingeben",
  task_tree_location: "Baum & Standort",
  task_tree_info: "Bauminformationen",
  task_tree_select: "Baum",
  task_tree_select_placeholder: "Baum auswählen",
  task_location: "Standort",
  task_location_placeholder: "Standort eingeben",
  task_due_date: "Fälligkeitsdatum",
  task_priority: "Priorität",
  project_name: "Projekt",
  task_status: "Status",
  task_type: "Aufgabenart",
  task_comments: "Kommentare",
  task_attachments: "Anhänge",
  task_plan: "Aufgabenplan",
  completed_tasks: "Erledigte Aufgaben",
  planned_tasks: "Geplante Aufgaben",
  next_task: "Nächste Aufgabe",
  create_task: "Aufgabe erstellen",
  delete_task: "Löschen",
  save_changes: "Änderungen speichern",
  add_comment: "Kommentar hinzufügen",
  upload_file: "Datei hochladen",
  cancel: "Abbrechen",
  optional: "optional",
  no_tasks: "Keine Aufgaben vorhanden",
  no_tasks_subtitle: "Erstellen Sie Ihre erste Aufgabe",
  no_results: "Keine Ergebnisse",
  no_results_action: "Filter zurücksetzen",
  tasks_completed_short: "abgeschlossen",
  more_tasks: "weitere",
  month_january: "Januar",
  month_february: "Februar",
  month_march: "März",
  month_april: "April",
  month_may: "Mai",
  month_june: "Juni",
  month_july: "Juli",
  month_august: "August",
  month_september: "September",
  month_october: "Oktober",
  month_november: "November",
  month_december: "Dezember",
  day_monday: "Mo",
  day_tuesday: "Di",
  day_wednesday: "Mi",
  day_thursday: "Do",
  day_friday: "Fr",
  day_saturday: "Sa",
  day_sunday: "So",
  overview: "Übersicht",
  alerts: "Alarme",
  tree_inventory: "Baumbestand",
  single_tree_view: "Einzelbaumansicht",
  master_data: "Stammdatenverwaltung",
  documents: "Dokumente",
  import_export: "Import/Export",
  live_monitoring: "Live-Monitoring",
  sensor_configuration: "Sensorkonfiguration",
  limits_alerts: "Alarme & Grenzwerte",
  data_graphs: "Messreihen & Graphen",
  maintenance: "Pflegemaßnahmen",
  ticket_system: "Ticketsystem",
  resource_planning: "Ressourcenplanung",
  condition_reports: "Zustandsberichte",
  cost_analysis: "Kostenanalyse",
  development_trends: "Entwicklungstrends",
  risk_assessment: "Risikobewertung",
  interactive_map: "Interaktive Karte",
  heatmaps: "Heatmaps",
  area_management: "Standortmanagement",
  open_sidebar: "Sidebar öffnen",
  close_sidebar: "Sidebar schließen",
  keyboard_shortcuts: "Tastaturkürzel",
  navigation: "Navigation",
  general: "Allgemein",
  menu: "Menü",
  toggle_project_sidebar: "Projekt-Sidebar umschalten",
  toggle_mobile_menu: "Mobile-Menü umschalten",
  focus_search: "Suche fokussieren",
  show_shortcuts: "Tastaturkürzel anzeigen",
  close_overlays: "Overlays schließen",
  data_analysis: "Datenanalyse",
  tree_form_info: {
    add_title: "Baum hinzufügen",
    edit_title: "Baum bearbeiten",
    profile: {
      heading: "Baum-Profil",
      cadastre_label: "Baumkataster-Nr.:",
      cadastre_help: "Optionale Kennung aus dem Kataster (max. 24 Zeichen).",
      name_label: "Name:",
      name_help: "Beschreibender Name (max. 40 Zeichen).",
      note: "Diese Angaben können später im Baum-Detail bearbeitet werden.",
    },
    position: {
      heading: "Position",
      latlng_label: "Breite / Länge*: ",
      latlng_help: "Pflichtfelder. Koordinaten eingeben oder Marker in der Karte setzen.",
      altitude_label: "Höhe:",
      altitude_help: "Optional. Leer lassen, wenn unbekannt.",
      map_label: "Karte:",
      map_help: "Kartenwerkzeuge zum Zoomen/Verschieben nutzen und die Position exakt setzen.",
      note: "Exakte Koordinaten verbessern Analysen und Kartenansichten.",
    },
    more: {
      heading: "Weitere Informationen",
      phase_label: "Pflegephase:",
      phase_help: "Fertigstellung, Entwicklung oder Unterhaltung wählen.",
      year_label: "Pflanzjahr:",
      year_help: "Jahr der Pflanzung auswählen.",
      species_label: "Baumart:",
      species_help: 'Suche im Format "lat. Name | ge. Name".',
      metrics_label: "Maße:",
      metrics_help: "Stammumfang (cm), Höhe (m), Kronendurchmesser (m) — optional.",
      note: "Hilfreich für Reporting und Empfehlungen; kann später ergänzt werden.",
    },
    sensors: {
      heading: "Sensoren",
      help: "Vorhandene TreeSense-Sensoren diesem Baum zuordnen oder Zuordnung lösen.",
      note: "Zuordnungen können später im Baum-Detail geändert werden.",
    },
    represent: {
      heading: "Repräsentationsbaum",
      help: "Optional festlegen, dass dieser Baum andere Bäume repräsentiert (Clustering).",
    },
    soil: {
      heading: "Boden",
      pwp_label: "PWP:",
      pwp_help: "Permanenter Welkepunkt (z. B. 10).",
      max_nf_label: "Max. nutzbares Feldwasser (max_nf):",
      max_nf_help: "Typischer Wert, z. B. 25.",
      max_f_label: "Feldkapazität (max_f):",
      max_f_help: "Typischer Wert, z. B. 45.",
      note: "Nur nötig, wenn Sie mit Bodenwasser-Schätzungen arbeiten.",
    },
  },
  soil_info: {
    heading: "Bodenparameter verstehen",
    intro: "Diese Werte beschreiben die Wasserspeicherfähigkeit des Bodens an diesem Standort:",
    items: {
      pwp_label: "Permanenter Welkepunkt (PWP):",
      pwp_help:
        "Wassergehalt, unter dem Pflanzen nicht mehr genügend Wasser aufnehmen können und welken.",
      efc_label: "Nutzbare Feldkapazität (nFK):",
      efc_help:
        "Wassermenge, die Pflanzen tatsächlich aufnehmen können (zwischen PWP und Feldkapazität).",
      fc_label: "Feldkapazität (FK):",
      fc_help: "Maximale Wassermenge, die der Boden gegen die Schwerkraft halten kann.",
    },
    note: "Diese Parameter werden standortspezifisch konfiguriert und beeinflussen die Bewässerungsempfehlungen.",
  },
  health_state_info: {
    heading: "Ampel-System: Bewässerungsbedarf verstehen",
    intro: "Das Ampel-System zeigt auf einen Blick, ob ein Baum bewässert werden muss:",
    states: {
      green_label: "🟢 Grün – Keine Bewässerung nötig:",
      green_help: "Der Baum hat ausreichend Wasser.",
      yellow_label: "🟡 Gelb – Bewässerung empfohlen:",
      yellow_help: "Wenn kapazitativ möglich, jetzt bewässern.",
      red_label: "🔴 Rot – Bewässerung dringend nötig:",
      red_help: "Sofort bewässern!",
      gray_label: "⚪ Grau – Unbekannt:",
      gray_help: "Sensor nicht verfügbar oder keine Daten.",
      blue_label: "🔵 Blau – Zu feucht:",
      blue_help: "Übermäßige Bewässerung; Gefahr von Vernässung.",
    },
    note: "Wichtig: Die Ampel basiert auf Messwerten und konfigurierten Schwellwerten für diesen Baum, Bodentyp und Standort.",
  },
  pwp_info: {
    heading: "Permanenter Welkepunkt (PWP)",
    intro:
      "Der permanente Welkepunkt ist der Bodenwassergehalt, bei dem Pflanzen kein Wasser mehr aufnehmen können.",
    when_reached: "Wenn die Bodenfeuchte diesen Wert erreicht oder unterschreitet:",
    bullets: {
      a: "Die Pflanze kann nicht mehr genügend Wasser aufnehmen",
      b: "Irreversible Schäden können entstehen",
      c: "Sofortige Bewässerung ist kritisch",
    },
    note: "Typische Werte: 10–15% (abhängig vom Bodentyp)",
  },
  efc_info: {
    heading: "Nutzbare Feldkapazität (nFK)",
    intro: "Die nFK ist die Wassermenge, die Pflanzen tatsächlich zur Verfügung steht.",
    formula_intro:
      "Sie wird als Differenz zwischen Feldkapazität und permanentem Welkepunkt berechnet:",
    bullets: {
      a: "nFK = FK − PWP",
      b: "Zeigt das pflanzenverfügbare Wasser",
      c: "Wichtig für die Bewässerungsplanung",
    },
    note: "Höhere Werte = Boden kann mehr Wasser speichern und Pflanzen länger versorgen",
  },
  fc_info: {
    heading: "Feldkapazität (FK)",
    intro:
      "Die Feldkapazität ist die maximale Wassermenge, die der Boden gegen die Schwerkraft halten kann.",
    after_rain: "Nach Bewässerung oder Regen:",
    bullets: {
      a: "Überschüssiges Wasser versickert",
      b: "Der Boden stellt sich auf die Feldkapazität ein",
      c: "Optimal ist es, mit der Bewässerung zu beginnen, bevor der PWP erreicht wird",
    },
    note: "Typische Werte: 35–50% (abhängig vom Bodentyp)",
  },
  map_sidebar_info: {
    title: "Kartenansicht – Flächen und Bäume",
    heading: "Navigation in der Kartenansicht",
    description:
      "Diese Seitenleiste zeigt alle Bewässerungsflächen und deren Bäume in einer hierarchischen Liste.",
    features_heading: "Funktionen:",
    features: {
      expand_areas_label: "Flächen aufklappen:",
      expand_areas_help: "Klicken Sie auf eine Fläche, um alle zugehörigen Bäume anzuzeigen.",
      select_tree_label: "Baum auswählen:",
      select_tree_help:
        "Klicken Sie auf einen Baum, um ihn auf der Karte anzuzeigen und Details zu öffnen.",
      add_tree_label: "Baum hinzufügen:",
      add_tree_help: "Nutzen Sie das Plus-Symbol, um neue Bäume zu einer Fläche hinzuzufügen.",
      parent_child_label: "Eltern-Kind-Beziehungen:",
      parent_child_help:
        "Bäume mit Sensoren können als Elternbäume fungieren und weitere Bäume repräsentieren.",
    },
    note: "Die Farbcodierung der Bäume entspricht ihrem Gesundheitszustand (grün = gesund, gelb = austrocknend, rot = trocken, grau = unbekannt).",
  },
  filter_by_project: "Nach Projekt filtern",
  clear_filter: "Filter löschen",
  date_time: "Datum/Zeit",
  other: "Sonstige",
  project_not_found: "Projekt nicht gefunden",
  tree_water_deficit: "Wasserdefizit des Baumes",
  diameter_minus_start: "Durchmesseränderung seit Start",
  tree_info_help: {
    heading: "Was du hier siehst",
    description:
      "Dieser Tab zeigt die Stammdaten des ausgewählten Baums (Art, Maße, Standort und Status). Er liefert Kontext für Sensorwerte und die Pflegehistorie.",
    fields_heading: "Felder erklärt",
    fields: {
      species_label: "Baumart",
      species_help: "Wissenschaftlicher Name (und deutscher Name, falls vorhanden).",
      dimensions_label: "Maße",
      dimensions_help:
        "Höhe, Kronendurchmesser und Stammumfang basierend auf den zuletzt erfassten Inventurwerten.",
      year_phase_label: "Pflanzjahr & Phase",
      year_phase_help:
        "Pflanzjahr (ggf. geschätzt) und Einordnung in eine Entwicklungs-/Lebensphase (z. B. Fertigstellung, Entwicklung, Alterung).",
      location_label: "Standort",
      location_help: "Koordinaten (WGS84 Breite/Länge) zur Verortung des Baums auf der Karte.",
      status_label: "Baumstatus",
      status_help:
        "Aktueller Status (z. B. kein Trockenstress / Trockenstress) – abhängig von Projektregeln und verfügbarer Sensorik.",
    },
    note: "Tipp: Wenn du berechtigt bist, kannst du Stammdaten über das Stift-Symbol bearbeiten.",
  },
  load_data: "Lade Daten",
  error_loading_customers: "Fehler beim Laden der Kunden",
  recommendations: "Empfehlungen",
  error_loading_trees: "Fehler beim Laden der Bäume",
  error_loading_users: "Fehler beim Laden der Benutzer",
  foliagedensity: "Blattdichte",
  change: "Ändern",
  download: "Download",
  qr_scanner: "QR-Scanner",
  select_camera: "Kamera auswählen",
  cloase_area_list: "Standortliste schließen",
  confirm_delete: "Löschen bestätigen",
  create_customer: "Kunde anlegen",
  downloading: "Download läuft…",
  inspector: "Baumkontrolleur",
  installation: "Installation",
  installed_sensors: "Installierte Sensoren",
  loading_trees: "Bäume werden geladen…",
  manage_parent_child_relationships: "Eltern-Kind-Beziehungen verwalten",
  manage_trees_without_sensors: "Bäume ohne Sensoren verwalten",
  next_inspection_date: "Nächstes Kontrolldatum",
  no_sensor_mode: "Modus ohne Sensoren",
  no_trees_available: "Keine Bäume verfügbar",
  not_found: "Nicht gefunden",
  open: "Öffnen",
  parent_child_mode: "Eltern-Kind-Modus",
  projects_views: "Projekte",
  reset: "Zurücksetzen",
  search: "Suche",
  search_address: "Adresse suchen",
  select_child_trees: "Kindbäume auswählen",
  sensors_views: "Sensoren",
  start_scanning: "Scan starten",
  treeNoSensor: "Baum ohne Sensor",
  tree_management_mode: "Baumverwaltungsmodus",
  trees_views: "Bäume",
  type_an_adress: "Adresse eingeben",
  creating: "Wird erstellt",
  customer_name: "Kundenname",
  proj: "Projekt",
  risklevel: "Risikostufe",
  close_areas_list: "Standortliste schließen",
  customer_creation_code: "Kundenerstellungs-Code",
  password_reset_request_sent_generic:
    "Falls für diese E-Mail-Adresse ein Konto existiert, senden wir Ihnen einen Link zum Zurücksetzen des Passworts",
  position_confirmed: "Position bestätigt",
  use_my_location: "Meinen Standort verwenden",
  assessment_date: "Bewertungsdatum",
  confirm_delete_task_message: "Möchten Sie diese Aufgabe wirklich löschen?",
  install_sensor: "Sensor installieren",
  history: "Historie",
  sesnor_height_hint: "Sensor-Icon ziehen oder die Höhe eingeben. Werte werden gerundet.",
  care_chat: {
    measure_irrigation: "Bewässerung",
    measure_pruning: "Schnittmaßnahme",
    measure_inspection: "Regelkontrolle",
    measure_free: "Freie Eintragung",
    sensor_install_task: "Sensor am Baum montieren",
    sensor_maintenance_task: "Sensorwartung am Baum durchführen",
    add_entry: "Eintrag hinzufügen",
    fill_checklist: "Checkliste ausfüllen",
    fill_protocol: "Protokoll ausfüllen",
    select_placeholder: "Auswählen",
    back: "Zurück",
    save: "Speichern",
    cancel: "Abbrechen",
    yes: "Ja",
    no: "Nein",
    responsible_person: "Verantwortliche Person",
    responsible_person_required: "Verantwortliche Person (Pflicht)",
    short_description_optional: "Kurzbeschreibung (optional)",
    short_description_placeholder: "Kurzbeschreibung",
    datetime: "Datum & Uhrzeit",
    date: "Datum",
    today: "Heute",
    tomorrow: "Morgen",
    in_one_week: "In einer Woche",
    in_one_month: "In einem Monat",
    time: "Uhrzeit",
    remarks: "Bemerkungen",
    cost_center: "Kostenzuordnung",
    assignment: "Zuweisung",
    description: "Beschreibung",
    please_select_person: "Bitte Person auswählen.",
    future_date_required: "Bitte ein zukünftiges Datum und eine zukünftige Uhrzeit wählen.",
    please_provide_type: "Bitte Art angeben.",
    please_provide_tree_condition: "Bitte Baumzustand angeben.",
    weather_sunny: "sonnig",
    weather_cloudy: "bewölkt",
    weather_rain_before: "regen vorher",
    weather_rain_after: "regen nachher",
    weather_windy: "windig",
    weather_dry: "trocken",
    soil_dry: "trocken",
    soil_slightly_moist: "leicht feucht",
    soil_wet: "nass",
    tree_condition_healthy: "gesund",
    tree_condition_wilted_leaves: "Blätter welk",
    tree_condition_damage: "Schäden",
    tree_condition_tilt: "Neigung",
    tree_condition_other: "Sonstiges",
    irrigation_protocol_title: "Bewässerungsprotokoll ausfüllen",
    water_amount_liters: "Menge Wasser (Liter)",
    water_amount_required: "Bitte Wassermenge angeben.",
    irrigation_method: "Bewässerungsmethode",
    irrigation_method_placeholder: "z.B. manuell, Gießsack, Tankwagen",
    reason: "Grund / Anlass",
    reason_placeholder: "regelmäßig, Trockenheit, ...",
    weather_conditions: "Wetterbedingungen",
    soil_moisture: "Bodenfeuchte",
    tree_condition: "Baumzustand",
    tree_condition_required: "Baumzustand (Pflicht)",
    tree_condition_placeholder: "z.B. gesund, Schäden, Pilzbefall",
    pruning_protocol_title: "Schnittprotokoll ausfüllen",
    pruning_type: "Art der Schnittmaßnahme",
    pruning_type_required: "Art der Schnittmaßnahme (Pflicht)",
    pruning_formative: "Erziehungsschnitt",
    pruning_maintenance: "Pflegeschnitt",
    pruning_crown_reduction: "Kroneneinkuerzung / Kronenpflege",
    pruning_clearing: "Freistellen / Freischnitt",
    pruning_remedial: "Sanierungsschnitt (Erhaltungsschnitt / Korrekturschnitt)",
    pruning_safety: "Sicherheitsschnitt (Verkehrssicherheitsschnitt)",
    inspection_title: "Regelkontrolle dokumentieren",
    inspection_data: "Kontrolldaten",
    inspected_by: "Kontrolliert von",
    interval_years: "Intervall (Jahre)",
    next_inspection: "Nächste Kontrolle",
    road_safe: "Verkehrssicher",
    further_action_title: "Weiteres Vorgehen",
    action_required: "Handlungsbedarf",
    consult_specialist: "Abstimmung mit Fachabteilung",
    detailed_investigation: "Eingehende Untersuchungen",
    tree_care_measures: "Baumpflegerische Maßnahmen",
    tree_care_measures_hint:
      "z.B. Totholzbeseitigung, Lichtraumprofilschnitt, Kronensicherungsschnitt",
    inspection_intervals: "Kontrollintervalle",
    interval_future_every: "künftig alle",
    interval_years_annual: "Jahre / jährlich",
    interval_as_before: "wie bisher",
    felling: "Fällung",
    completion: "Erledigung",
    immediately: "sofort",
    within: "innerhalb von",
    weeks: "Wochen",
    remarks_label: "Anmerkungen",
    fill_form: "Formular ausfüllen",
    upload_document: "Dokument hochladen",
    upload_document_hint: "PDF, Bild oder Dokument hier ablegen oder klicken",
    remove: "Entfernen",
    follow_up_inspection: "Regelkontrolle (Folgetermin)",
    remark_optional: "Bemerkung (optional)",
    status_planned: "Geplant",
    status_commissioned: "Beauftragt",
    status_in_progress: "In Arbeit",
    status_done: "Erledigt",
    status_not_done: "Nicht geschafft",
    priority: "Priorität",
    priority_low: "Niedrig",
    priority_medium: "Mittel",
    priority_high: "Hoch",
    priority_critical: "Kritisch",
    amount: "Menge:",
    method: "Methode:",
    cut_type: "Schnittart:",
    scope: "Umfang:",
    inspection_level: "Kontrollstufe:",
    finding: "Befund:",
    recommendation: "Empfehlung:",
    reason_display: "Grund:",
    executor: "Ausführende:",
    deadline: "Frist:",
    cost_center_display: "Kostenzuordnung:",
    assignment_display: "Zuweisung:",
    description_display: "Beschreibung:",
    irrigation_log_title: "Bewässerungsprotokoll",
    datetime_display: "Datum / Uhrzeit:",
    water_amount_display: "Menge Wasser:",
    irrigation_method_display: "Bewässerungsmethode:",
    reason_label: "Grund / Anlass:",
    weather_display: "Wetterbedingungen:",
    soil_moisture_display: "Bodenfeuchte:",
    tree_condition_display: "Baumzustand:",
    responsible_person_display: "Verantwortliche Person:",
    remarks_display: "Bemerkungen:",
    pruning_log_title: "Schnittprotokoll",
    pruning_type_display: "Art:",
    inspected_by_display: "Kontrolliert von:",
    inspection_date_display: "Kontrolldatum:",
    next_inspection_display: "Nächste Kontrolle:",
    interval_display: "Intervall:",
    road_safe_display: "Verkehrssicher:",
    remark_display: "Bemerkung:",
    attachment_display: "Anhang:",
    show_less: "Weniger anzeigen",
    show_more: "Mehr anzeigen",
    all_statuses: "Alle Status",
    all_priorities: "Alle Prioritäten",
    all_types: "Alle Typen",
    sort_by_date: "Sortieren nach Datum",
    sort_by_priority: "Sortieren nach Priorität",
    add_photo: "Foto hinzufügen",
    no_entries_found: "Keine Einträge gefunden.",
    no_tasks_found: "Keine Aufgaben gefunden.",
    next_inspection_label: "Nächste Kontrolle:",
    no_inspection_planned: "Keine Kontrolle geplant.",
    plan_inspection: "Kontrolle planen",
    perform_inspection: "Kontrolle durchführen",
    delete: "Löschen",
    appointment_label: "Termin:",
    edit: "Bearbeiten",
    mark_not_done: "Als nicht erledigt markieren",
    mark_done: "Als erledigt markieren",
    favorite: "Favorisieren",
    reschedule: "Verschieben",
    reschedule_title: "Termin verschieben",
    overdue_since_days: "Überfällig seit {{days}} Tagen",
    in_days: "In {{days}} Tagen",
    overdue_since_hours: "Überfällig seit {{hours}} Std.",
    in_hours: "In {{hours}} Std.",
  },
  change_position: "Position ändern",
  remove: "Entfernen",
  install: "Installieren",
  thresholds: "Schwellenwerte",
  thresholds_select_one_sensor: "Wählen Sie genau einen Sensor aus, um Schwellenwerte anzuzeigen.",
  cookie_consent: {
    banner_title: "Cookie-Einstellungen",
    banner_description:
      "Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Sie können Ihre Präferenzen anpassen oder alle Cookies akzeptieren.",
    accept_all: "Alle akzeptieren",
    accept_essential: "Nur notwendige",
    customize: "Anpassen",
    save_preferences: "Einstellungen speichern",
    essential_cookies: "Notwendige Cookies",
    essential_cookies_description:
      "Diese Cookies sind für das Funktionieren der Website unerlässlich und können nicht deaktiviert werden. Sie werden in der Regel nur als Reaktion auf von Ihnen vorgenommene Aktionen gesetzt, wie z.B. das Festlegen Ihrer Datenschutzeinstellungen, das Anmelden oder das Ausfüllen von Formularen.",
    analytics_cookies: "Analyse-Cookies",
    analytics_cookies_description:
      "Diese Cookies ermöglichen es uns, Besuche und Verkehrsquellen zu zählen, damit wir die Leistung unserer Website messen und verbessern können. Sie helfen uns zu verstehen, welche Seiten am beliebtesten sind und wie Besucher sich auf der Website bewegen.",
    marketing_cookies: "Marketing-Cookies",
    marketing_cookies_description:
      "Diese Cookies können von unseren Werbepartnern über unsere Website gesetzt werden. Sie können verwendet werden, um ein Profil Ihrer Interessen zu erstellen und Ihnen relevante Werbung auf anderen Websites anzuzeigen.",
    preferences_cookies: "Präferenz-Cookies",
    preferences_cookies_description:
      "Diese Cookies ermöglichen es der Website, sich an Ihre Entscheidungen zu erinnern (wie z.B. Ihren Benutzernamen, Ihre Sprache oder die Region, in der Sie sich befinden) und erweiterte, persönlichere Funktionen bereitzustellen.",
    cookie_policy: "Cookie-Richtlinie",
    privacy_policy: "Datenschutzerklärung",
    settings_title: "Cookie-Einstellungen",
    settings_description:
      "Verwalten Sie Ihre Cookie-Präferenzen. Änderungen werden sofort wirksam.",
    last_updated: "Zuletzt aktualisiert",
    preferences_saved: "Ihre Cookie-Einstellungen wurden gespeichert.",
    preferences_error: "Fehler beim Speichern der Einstellungen.",
  },
  tree_wiki: "Baum-Wiki",
  sensor_already_installed: "Dieser Sensor ist bereits aktiv installiert",
  please_select_sensor: "Bitte wählen Sie einen Sensor aus.",
  installation_save_failed:
    "Die Installation konnte nicht gespeichert werden. Bitte versuchen Sie es ernuet.",
  beta_ended: {
    title: "Beta-Phase beendet",
    subtitle: "Die Testphase ist vorbei",
    description:
      "Vielen Dank für die Nutzung der Beta-Version! Alle Änderungen und Verbesserungen aus der Beta-Phase wurden eingearbeitet und stehen Ihnen nun in der TreeSense Cloud zur Verfügung.",
    link_text: "Zur TreeSense Cloud",
  },
  improvements: "Verbesserungen",
  moisture_formula_setting: "Feuchtigkeitsgehalts-Formel",
  use_new_moisture_formula: "Neue Formel verwenden",
  moisture_formula_hint:
    "Die neue Formel kompensiert Temperatureffekte besser und liefert stabilere Werte.",
  new_formula: "Neue Formel",
  old_formula: "Alte Formel",
  moisture_formula_new_description:
    "Generell stabiler, da sie den Temperatureffekt in der Regel besser kompensiert. Dies kann jedoch dazu führen, dass etwaige Bewässerungen oder Regenereignisse schlechter zu erkennen sind.",
  moisture_formula_old_description:
    "Stärker Temperaturschwankungen ausgesetzt, kann aber Bewässerungen und Regenereignisse deutlicher anzeigen.",
  moisture_formula_improvements:
    "Wir haben das Setup zur Temperaturkalibrierung deutlich verbessert und automatisiert. Früher wurde nur die Schwarzpappel kompensiert. Jetzt versuchen wir, möglichst alle Baumarten zu kompensieren. Sofern dies nicht möglich ist, verwenden wir die phylogenetisch nächste Baumart.",
  moisture_formula_threshold_warning:
    "Mit der neuen Formel ändern sich auch die Grenzwerte. Diese müssen nach der Umstellung überprüft und angepasst werden, damit Warnungen und Bewertungen weiterhin korrekt sind.",
  moisture_formula_learn_more: "Mehr erfahren",
  moisture_formula_wiki_link:
    "https://www.treesense.net/wiki_post/treesense-pulse-was-ist-der-treesense-feuchtigkeitsindex/",
  moisture_formula_note:
    "Hinweis: Die Wahl der Formel beeinflusst die Darstellung der Feuchtigkeitswerte in allen Grafiken.",
  moisture_content_display_setting: "Feuchtegehalt-Anzeige",
  moisture_content_display_description: "Wähle, wie TreeSense Feuchtegehalt-Werte anzeigt.",
  moisture_content_display_fraction: "Bruchteil (0-1)",
  moisture_content_display_fraction_description: "Zeigt Werte als 0,34 an.",
  moisture_content_display_percent: "Prozent (0-100)",
  moisture_content_display_percent_description: "Zeigt Werte als 34 % an.",
  moisture_content_cap_setting: "Feuchtegehalt-Werte begrenzen",
  moisture_content_cap_description:
    "Werte auf 0-1 / 0-100 % begrenzen. Deaktivieren, um analytische Rohwerte anzuzeigen.",
  table_column_preferences: "Sichtbare Spalten",
  table_column_preferences_hint:
    "Legen Sie fest, welche Spalten in den Tabellen für Bäume, Sensoren und Aufgaben angezeigt werden.",
  mobile_table_column_preferences: "Mobile Spalten",
  mobile_table_column_preferences_hint:
    "Legen Sie fest, welche 2 Spalten auf mobilen Geräten (Handy) angezeigt werden.",
  mobile_column: "Spalte",
  table_columns_trees: "Bäume",
  table_columns_sensors: "Sensoren",
  table_columns_tasks: "Aufgaben",
  reset_table_column_preferences: "Standard wiederherstellen",
  move_up: "Nach oben",
  move_down: "Nach unten",
  settings_saved_successfully: "Einstellungen erfolgreich gespeichert",
  action: "Maßnahme",
  back: "Zurück",
  download_successful: "Download erfolgreich",
  evaluation: "Auswertung",
  filter: "Filtern",
  from: "Von",
  inactive: "Inaktiv",
  last_date: "Letztes Datum",
  more_information: "Mehr Informationen",
  no_data: "Keine Daten verfügbar",
  no_data_found: "Keine Daten gefunden",
  no_sensors_found: "Keine Sensoren gefunden",
  position: "Position",
  refresh_health: "Gesundheitsdaten aktualisieren",
  refresh_health_error: "Aktualisierung der Gesundheitsdaten fehlgeschlagen",
  required: "Erforderlich",
  select_sensor_search: "Nach Sensor suchen...",
  something_wrong: "Etwas ist schiefgelaufen",
  start_typing_to_search: "Zum Suchen eingeben...",
  to: "Bis",

  // NB-IoT Sensorkonfiguration
  weekly_signal_avg: "Signalstärke (7d Ø)",
  signal_strength: "Signal",
  signal_low: "Niedrig",
  signal_medium: "Mittel",
  signal_high: "Hoch",
  signal_strength_info:
    "Die Signalstärke beeinflusst die Batterielebensdauer. Niedriges Signal verbraucht am meisten Batterie, Mittleres mehr als Hohes, und Hohes ist am effizientesten.",
  signal_no_data: "Keine Daten",
  send_interval: "Sendeintervall",
  measurement_interval: "Messintervall",
  send_configuration: "Konfiguration senden",
  downlink_queued: "Konfiguration für nächsten Uplink eingereiht",
  downlink_failed: "Konfiguration konnte nicht gesendet werden",
  confirm_send_downlink: "Möchten Sie die Konfiguration wirklich an den Sensor senden?",
  no_intervals_configured: "Keine Intervalle konfiguriert",
  interval_5min: "5 Minuten",
  interval_10min: "10 Minuten",
  interval_15min: "15 Minuten",
  interval_30min: "30 Minuten",
  interval_1h: "1 Stunde",
  interval_2h: "2 Stunden",
  interval_4h: "4 Stunden",
  interval_6h: "6 Stunden",
  interval_12h: "12 Stunden",
  interval_24h: "24 Stunden",

  // Irrigation Export
  export_irrigation_tasks_short: "Exportieren",
  export_irrigation_tasks_description:
    "Exportieren Sie Bewässerungsaufgaben nach Excel für einen bestimmten Mitarbeiter und Zeitraum.",
  export_irrigation_tasks_description_v2:
    "Exportieren Sie den Bewässerungsplan nach Excel für einen bestimmten Mitarbeiter. Zeigt alle Bewässerungen der aktuellen Vegetationsperiode (April - Oktober).",
  export_filter_assignee_hint: "Leer lassen, um Aufgaben für alle Mitarbeiter zu exportieren",
  export_date_range_hint: "Wählen Sie den Zeitraum für zu exportierende Aufgaben aus",
  no_irrigation_tasks_found:
    "Keine Bewässerungsaufgaben für die gewählten Filter gefunden. Bitte prüfen Sie den Mitarbeiter und Zeitraum.",
  tree_number: "Baum-Nr.",
  sensor_installed: "Sensor installiert",
  responsible_person: "Verantwortlicher",
  irrigation_abbrev: "Bew.",
  irrigation_plan: "Bewässerungsplan",
  represented_trees: "Mitzubewässernde Bäume",
  irrigation_export_title: "Bewässerungsplan exportieren",
  irrigation_export_button: "Export",
  yes: "Ja",
};
